import { createContext } from "react";

const Colors = createContext()
const RuleColorCode = createContext()
 
export {
           Colors, 
           RuleColorCode
}